// src/pages/CheckoutCancel.js — Página de cancelamento do checkout Stripe
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button, Stack } from '@mui/material';

export default function CheckoutCancel() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center' }}>
          <Box sx={{
            width: 100, height: 100, borderRadius: '50%',
            bgcolor: 'rgba(239,68,68,0.1)', border: '3px solid rgba(239,68,68,0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            mx: 'auto', mb: 3, fontSize: '3rem'
          }}>✕</Box>

          <Typography variant="h4" fontWeight="bold" color="white" mb={1}>
            Pagamento Cancelado
          </Typography>
          <Typography variant="body1" color="rgba(255,255,255,0.6)" maxWidth={400} mx="auto" mb={4}>
            Não se preocupe — seus dados foram salvos. Você pode retornar e finalizar a assinatura quando quiser.
          </Typography>

          <Box sx={{ bgcolor: '#1e293b', borderRadius: 3, p: 3, border: '1px solid rgba(255,255,255,0.08)', mb: 4, textAlign: 'left' }}>
            <Typography variant="body2" color="rgba(255,255,255,0.6)" lineHeight={1.7}>
              Se tiver alguma dúvida sobre os planos ou precisar de ajuda para finalizar a assinatura, nossa equipe está disponível pelo WhatsApp ou e-mail.
            </Typography>
          </Box>

          <Stack spacing={2}>
            {/* Out/26: ia pro cadastro do zero, que parava em "E-mail já
                cadastrado". Com a conta já criada, retoma no passo que faltou. */}
            <Button
              variant="contained" fullWidth size="large"
              onClick={() => navigate(localStorage.getItem('token') ? '/register?retomar=1' : '/register')}
              sx={{ bgcolor: '#25d366', py: 1.8, fontWeight: 700, textTransform: 'none', fontSize: '1rem', borderRadius: 2, '&:hover': { bgcolor: '#1db954' } }}
            >
              Tentar Novamente
            </Button>
            <Button
              variant="outlined" fullWidth size="large"
              onClick={() => navigate('/')}
              sx={{ color: 'rgba(255,255,255,0.7)', borderColor: 'rgba(255,255,255,0.2)', textTransform: 'none', borderRadius: 2 }}
            >
              Ver Planos Novamente
            </Button>
            <Button variant="text" fullWidth onClick={() => navigate('/dashboard')}
              sx={{ color: 'rgba(255,255,255,0.4)', textTransform: 'none' }}>
              Ir para o Dashboard
            </Button>
          </Stack>

          <Typography variant="caption" display="block" mt={3} color="rgba(255,255,255,0.3)">
            Suporte: contato@cettosystem.com.br | WhatsApp: (21) 99775-9098
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}